export default __webpack_public_path__ + "static/media/arrow-right-line-icon.7bc63007.svg";